import { Typography15, Typography20, Typography24, Typography34 } from "@slid/slid-ips";
import React, { memo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { trackEvent } from "utils/eventTracking";
import { eventTypes } from "types/eventTracking";
import { useAppSelector } from "hooks";

const CustomComponent = memo(() => {
  const { t } = useTranslation("ExtensionOnboardingModal");
  const { userData } = useAppSelector((state) => state.slidGlobal);

  return (
    <Container>
      {userData?.country === "South Korea" ? (
        <MainTitleContainer>
          <Typography20 weight={700} text={t("lastStepGuide")} color="--red5" />
          <TitleText weight={700} text={t("discountTitle")} color="--gray17" />
        </MainTitleContainer>
      ) : (
        <TitleText weight={700} text={t("title")} color="--gray17" />
      )}
      <CardWrapper>
        <YoutubeCardContainer
          onClick={() => {
            trackEvent({ eventType: eventTypes.click.START_FROM_YOUTUBE_IN_WEBSITE_SELECT_MODAL });
            window.location.assign(t("SlidGuideYoutubeLink", { ns: "common" }));
          }}
        >
          <YoutubeCardImage src="/src/design/assets/slid_extension_onboarding_modal.png" alt="youtube" />
          <RightContainer>
            <TitleContainer>
              <Typography24 weight={700} text={t("card1.title", { keySeparator: "." })} color="--gray17" />
              <Typography15 weight={500} text={t("card1.description", { keySeparator: "." })} color="--gray9" />
            </TitleContainer>

            <Typography20 weight={700} text={t("startButtonText")} color="--blue8" />
          </RightContainer>
        </YoutubeCardContainer>

        <OtherWebsiteCardContainer
          onClick={() => {
            trackEvent({ eventType: eventTypes.click.START_FROM_OTHER_WEBSITES_IN_WEBSITE_SELECT_MODAL });
            window.open("/video-note/new", "_self");
          }}
        >
          <OtherWebsiteCardTitle>
            <Typography20 weight={700} text={t("card2.title", { keySeparator: "." })} color="--gray14" />
            <Typography15 weight={500} text={t("card2.description", { keySeparator: "." })} color="--gray8" />
          </OtherWebsiteCardTitle>

          <Typography20 weight={700} text={"→"} color="--blue8" />
        </OtherWebsiteCardContainer>
      </CardWrapper>
    </Container>
  );
});

const Container = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: var(--white);
  border-radius: 30px;
  padding: 60px 90px;
  display: flex;
  flex-direction: column;
`;

const MainTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

const TitleText = styled(Typography34)`
  && {
    letter-spacing: -0.1rem;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 44px;
  gap: 24px;
`;

const CardContainer = styled.div`
  display: flex;
  cursor: pointer;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.25s ease-in;

  &:hover {
    background-color: #fefeff;
    box-shadow: 0px 4px 100px -30px rgba(0, 0, 0, 0.3);
  }
`;

const YoutubeCardContainer = styled(CardContainer)`
  display: flex;
  height: 249px;
`;

const YoutubeCardImage = styled.img`
  border-radius: 20px 0px 0px 20px;
  margin-left: -13px;
  width: 342px;
  height: 249px;
`;

const RightContainer = styled.div`
  width: 391px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: -7px;
  gap: 32px;
  padding-left: 40px;
  border: 1px solid var(--gray3);
  border-left: none;
  background: var(--gray1);
  border-radius: 0px 20px 20px 0px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const OtherWebsiteCardContainer = styled(CardContainer)`
  padding: 20px 20px 20px 40px;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  border: 1px solid var(--gray3);
  background: var(--gray1);
`;

const OtherWebsiteCardTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export default CustomComponent;
